/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerformanceStatistics } from './PerformanceStatistics';
import {
    PerformanceStatisticsFromJSON,
    PerformanceStatisticsFromJSONTyped,
    PerformanceStatisticsToJSON,
    PerformanceStatisticsToJSONTyped,
} from './PerformanceStatistics';

/**
 * 
 * @export
 * @interface TeamPerformanceStatistic
 */
export interface TeamPerformanceStatistic {
    /**
     * 
     * @type {string}
     * @memberof TeamPerformanceStatistic
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamPerformanceStatistic
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamPerformanceStatistic
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamPerformanceStatistic
     */
    categoryName?: string;
    /**
     * 
     * @type {number}
     * @memberof TeamPerformanceStatistic
     */
    matchesPlayed?: number;
    /**
     * 
     * @type {PerformanceStatistics}
     * @memberof TeamPerformanceStatistic
     */
    statistics?: PerformanceStatistics;
}

/**
 * Check if a given object implements the TeamPerformanceStatistic interface.
 */
export function instanceOfTeamPerformanceStatistic(value: object): value is TeamPerformanceStatistic {
    return true;
}

export function TeamPerformanceStatisticFromJSON(json: any): TeamPerformanceStatistic {
    return TeamPerformanceStatisticFromJSONTyped(json, false);
}

export function TeamPerformanceStatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamPerformanceStatistic {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'matchesPlayed': json['matchesPlayed'] == null ? undefined : json['matchesPlayed'],
        'statistics': json['statistics'] == null ? undefined : PerformanceStatisticsFromJSON(json['statistics']),
    };
}

export function TeamPerformanceStatisticToJSON(json: any): TeamPerformanceStatistic {
    return TeamPerformanceStatisticToJSONTyped(json, false);
}

export function TeamPerformanceStatisticToJSONTyped(value?: TeamPerformanceStatistic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
        'matchesPlayed': value['matchesPlayed'],
        'statistics': PerformanceStatisticsToJSON(value['statistics']),
    };
}

